import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { RiDeleteBinLine } from "react-icons/ri";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import ResizeListener from "../../../../utility/ResizeListener";
import CustomModal from "../../../components/customModal/CustomModal";
import { SUCCESS } from "../../../resources/constantsManager";
import AddAccountModal from "./UpdateAccountModal";
const AccountContainer = ({
  accountNumber,
  IFSC,
  index,
  onClickDelete,
  data,
}) => {
  const pStyle = {
    color: "black",
    fontSize: 14,
    fontFamily: "Roboto",
    fontWeight: "bold",
    padding: 0,
    margin: 0,
  };
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        minWidth: 300,
        justifyContent: "space-between",
        margin: "0px 40px",
        width: "24%",
        flexDirection: "column",
        backgroundColor: "#F3F8FF",
        padding: "10px 10px",
        borderRadius: 6,
        margin: "10px 0px",
      }}
      key={index}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <p
          style={{
            ...pStyle,
            width: "50%",
          }}
        >
          Account Number {index + 1}
        </p>
        <p
          style={{
            ...pStyle,
            width: "50%",
            fontWeight: "400",
            wordBreak: "break-all",
          }}
        >
          {accountNumber}
        </p>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <p
          style={{
            ...pStyle,
            width: "50%",
          }}
        >
          IFSC:
        </p>
        <p
          style={{
            ...pStyle,
            width: "50%",
            fontWeight: "400",
            wordBreak: "break-all",
          }}
        >
          {IFSC}
        </p>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          marginTop: 4,
        }}
      >
        <RiDeleteBinLine
          color="red"
          style={{
            cursor: "pointer",
          }}
          onClick={() => onClickDelete(data)}
        />
      </div>
    </div>
  );
};
function OtherDetails({ bankDetails, customerHashId, onSuccess }) {
  const { width } = ResizeListener();
  const [openAddAnotherAccount, setOpenAddAnotherAccount] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const pStyle = {
    color: "black",
    fontSize: 14,
    fontFamily: "Roboto",
    fontWeight: "bold",
    padding: 0,
    margin: 0,
  };

  const onClickDeleteAccount = (accountNumber, customerHashId, ifscCode) => {
    ApiRequestPost.deleteCustomerBankAccount({
      accountNumber,
      customerHashId,
      ifscCode,
    })
      .then((response) => {
        onSuccess();
        if (response.status === SUCCESS) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
      });
  };

  return (
    <div
      style={{
        height: "100%",
        padding: "0px 30px",
      }}
    >
      <div style={{}}>
        <p
          style={{
            ...pStyle,
          }}
        >
          Authorised Bank Account
        </p>
      </div>

      <div
        style={{
          maxHeight: 320,
          overflow: "scroll",
          marginBottom: 20,
        }}
      >
        {bankDetails &&
          bankDetails.map((bank, index) => (
            <AccountContainer
              accountNumber={bank?.accountNumber}
              IFSC={bank?.ifscCode}
              index={index}
              onClickDelete={(data) => {
                onClickDeleteAccount(
                  data?.accountNumber,
                  customerHashId,
                  data?.ifscCode
                );
              }}
              data={bank}
            />
          ))}
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          minWidth: 300,
          width: width * 0.35,
        }}
      >
        <p
          style={{
            ...pStyle,
            color: "dodgerblue",
            cursor: "pointer",
          }}
          onClick={() => {
            setOpenAddAnotherAccount(true);
          }}
        >
          Add another account
        </p>
      </div>

      {openAddAnotherAccount && (
        <CustomModal
          open={openAddAnotherAccount}
          onClose={() => {
            setOpenAddAnotherAccount(false);
          }}
        >
          <AddAccountModal
            onClose={() => {
              setOpenAddAnotherAccount(false);
            }}
            onSuccess={onSuccess}
            customerHashId={customerHashId}
          />
        </CustomModal>
      )}
    </div>
  );
}

export default OtherDetails;
